import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheMasterpieceHero() {
  return <section data-section-id="227670" id="the-art-of-the-remodel" className="dark bg-background text-foreground relative min-h-screen flex flex-col lg:flex-row overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/architectural_blueprint_grain.png)] opacity-15 mix-blend-overlay z-50"></div>

      {}
      <div className="w-full lg:w-[40%] flex flex-col justify-center px-8 py-24 lg:px-16 xl:px-24 relative z-20 bg-background lg:bg-transparent">
        <div className="max-w-xl">
          <h1 className="font-default text-foreground text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold uppercase leading-[0.9] tracking-tighter">
            The <span className="font-serif italic text-primary lowercase">Art</span> of the Remodel
          </h1>
          
          <p className="font-default text-muted-foreground mt-8 text-lg md:text-xl leading-relaxed max-w-md">
            Denver’s Premier Design-Build Partner. We transform residential spaces into bespoke architectural masterpieces with precision and craft.
          </p>
          
          <div className="mt-12">
            <Button size="lg" variant="default" asChild className="rounded-md px-10 py-7 text-sm tracking-[0.2em] uppercase shadow-2xl hover:shadow-primary/20 transition-all duration-300 bg-primary text-primary-foreground">
              <Link to="/OurPortfolioPage">View Our Portfolio</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="w-full h-[60vh] lg:h-auto lg:w-[60%] relative z-10">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/luxury_kitchen_remodel_denver.png" alt="BT Remodeling Luxury Kitchen Design" className="absolute inset-0 w-full h-full object-cover object-center" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent lg:bg-gradient-to-r lg:from-background lg:via-background/20 lg:to-transparent"></div>

        {}
        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4">
          <div className="w-[1px] h-16 bg-primary/50 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-primary animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>;
}